import React, { useRef, useState, useEffect } from "react";
import { TextField, InputAdornment } from '@mui/material';
import { isMobile } from 'react-device-detect';

const MuiTextField = (props) => {
  // const { defaultLabel, defaultValue, inputAdornment, fieldName, onChange, autoFocus, helperText, numberKeypad = false, errorHelperText, disabled = false, required, activityId = null } = props;
  const { defaultLabel, defaultValue, inputAdornment, fieldName, onChange, autoFocus, helperText, numberKeypad = false,
    errorHelperText, disabled = false, required, position="end", readOnly = false, onClick, activityId = null  } = props;
  const [value, setValue] = useState(defaultValue || "");
  const [touched, setTouched] = useState(false); // Track if the field has been focused
  const textFieldRef = useRef(null);

  useEffect(() => {
    if (defaultValue) {
      setValue(defaultValue);
    } else {
      setValue("");
    }
  }, [defaultValue]);

  useEffect(() => {
    if (autoFocus && textFieldRef.current) {
      textFieldRef.current.focus();
    }
  }, [autoFocus]);

  const handleKeyPress = (e) => {
    if (e.key === "Enter" && textFieldRef.current) {
      textFieldRef.current.focus();
    }
  };

  const handleChange = (e) => {
    setValue(e.target.value);
    if (onChange) {
      onChange(fieldName, e.target.value);
    }
  };

  const handleBlur = () => {
    setTouched(true); // Mark the field as touched when it loses focus
  };

  const showError = required && touched && !value; // Show error if required, touched, and empty

  const textFieldSx = {
    '& .MuiInputLabel-root': {
      color: '#3F4949',
      fontFamily: 'Inter',
    },
    '& .MuiInputLabel-root.Mui-focused': {
      color: '#00696D',
      fontFamily: 'Inter',
    },
    '& .MuiInputLabel-root.Mui-disabled': {
      color: '#B0B0B0',
    },
    '& .MuiFormLabel-asterisk.MuiInputLabel-asterisk': {
      visibility: 'hidden',
      '&::before': {
        content: '"*"',
        visibility: 'visible',
      },
    },
    '& .MuiTypography-root': {
      color: disabled ? '#B0B0B0' : '#6F7979',
      fontFamily: 'Inter',
    },
    '& .MuiInputBase-root.Mui-disabled': {
      backgroundColor: '#e1e1e1',
      color: '#B0B0B0',
    },
    '& .MuiInputLabel-root:not(.MuiInputLabel-shrink)': {
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
      maxWidth: isMobile ? "calc(100% - 100px)" : "calc(100% - 50px)",
    },
  };

  return (
    <TextField
      inputRef={textFieldRef}
      type={numberKeypad ? "text" : "text"}
      inputMode={numberKeypad ? "numeric" : "text"}
      pattern={numberKeypad ? "[0-9,.]*" : undefined}
      variant="outlined"
      label={defaultLabel}
      value={value}
      onChange={handleChange}
      onKeyDown={handleKeyPress}
      onBlur={handleBlur}
      error={showError || !!errorHelperText}
      helperText={showError ? 'Dette feltet er påkrevd' : (errorHelperText ? errorHelperText : (helperText ? helperText :  ' '))}
      fullWidth
      disabled={disabled}
      required={required}
      InputLabelProps={{ shrink: value !== null && value !== "" ? true : false }}
      InputProps={{
        [position === "start" ? "startAdornment" : "endAdornment"]: (
          <InputAdornment
            position={position}
            sx={{
              color: disabled ? '#B0B0B0' : '#6F7979',
              fontFamily: 'Inter',
              fontSize: '16px',
              fontStyle: 'normal',
              fontWeight: '400',
              lineHeight: '24px',
              letterSpacing: '0.5px'
            }}
          >
            {inputAdornment}
          </InputAdornment>
        ),
        readOnly: readOnly
      }}
      onClick={readOnly && onClick}
      sx={textFieldSx}
      FormHelperTextProps={{
        sx: activityId === 'act19' ? { height: '24px', margin: '0px' } : {}
      }}
    />
  );
};

export default MuiTextField;
